import React, { useState } from 'react';
import {
  FaGlobe,
  FaHandshake,
  FaAward,
  FaArrowRight,
  FaMapMarkedAlt,
  FaBuilding,
  FaChartLine
} from 'react-icons/fa';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { Link } from 'react-router';

// Composant pour afficher le drapeau via API
const CountryFlag = ({ countryCode, alt }) => {
  return (
    <img
      src={`https://flagcdn.com/w160/${countryCode}.png`}
      srcSet={`https://flagcdn.com/w320/${countryCode}.png 2x`}
      alt={alt}
      className="country-flag-img"
    />
  );
};

const NosPartenaires = () => {
  const countries = [
    {
      id: 'benin',
      name: 'Bénin',
      countryCode: 'bj',
      city: 'Cotonou',
      gradient: 'linear-gradient(135deg, #00853f 0%, #fcd116 100%)',
      url: '/partenaires/benin'
    },
    {
      id: 'togo',
      name: 'Togo',
      countryCode: 'tg',
      city: 'Lomé',
      gradient: 'linear-gradient(135deg, #006a4e 0%, #ffce00 100%)',
      url: '/partenaires/togo'
    },
    {
      id: 'niger',
      name: 'Niger',
      countryCode: 'ne',
      city: 'Niamey',
      gradient: 'linear-gradient(135deg, #e05206 0%, #0db02b 100%)',
      url: '/partenaires/niger'
    },
    {
      id: 'cotedivoire',
      name: 'Côte d\'Ivoire',
      countryCode: 'ci',
      city: 'Abidjan',
      gradient: 'linear-gradient(135deg, #f77f00 0%, #009e60 100%)',
      url: '/partenaires/cote-ivoire'
    },
    {
      id: 'gabon',
      name: 'Gabon',
      countryCode: 'ga',
      city: 'Libreville',
      gradient: 'linear-gradient(135deg, #009e60 0%, #fcd116 100%)',
      url: '/partenaires/gabon'
    },
    // {
    //   id: 'maroc',
    //   name: 'Maroc',
    //   countryCode: 'ma',
    //   city: 'Casablanca',
    //   gradient: 'linear-gradient(135deg, #c1272d 0%, #006233 100%)',
    //   url: '/partenaires/maroc'
    // },
    // {
    //   id: 'france',
    //   name: 'France',
    //   countryCode: 'fr',
    //   city: 'Paris',
    //   gradient: 'linear-gradient(135deg, #002395 0%, #ed2939 100%)',
    //   url: '/partenaires/france'
    // },
    {
      id: 'senegal',
      name: 'Sénégal',
      countryCode: 'sn',
      city: 'Dakar',
      gradient: 'linear-gradient(135deg, #00853f 0%, #fcd116 100%)',
      url: '/partenaires/senegal'
    },
    {
      id: 'mali',
      name: 'Mali',
      countryCode: 'ml',
      city: 'Bamako',
      gradient: 'linear-gradient(135deg, #14b53a 0%, #fcd116 100%)',
      url: '/partenaires/mali'
    },
    // {
    //   id: 'burkinafaso',
    //   name: 'Burkina Faso',
    //   countryCode: 'bf',
    //   city: 'Ouagadougou',
    //   gradient: 'linear-gradient(135deg, #ef2b2d 0%, #009e49 100%)',
    //   url: '/partenaires/burkina-faso'
    // },
    {
      id: 'cameroun',
      name: 'Cameroun',
      countryCode: 'cm',
      city: 'Yaoundé',
      gradient: 'linear-gradient(135deg, #007a5e 0%, #ce1126 100%)',
      url: '/partenaires/cameroun'
    },
    {
      id: 'congo',
      name: 'Congo',
      countryCode: 'cg',
      city: 'Brazzaville',
      gradient: 'linear-gradient(135deg, #009543 0%, #fbde4a 100%)',
      url: '/partenaires/congo'
    },
    {
      id: 'rdc',
      name: 'RD Congo',
      countryCode: 'cd',
      city: 'Kinshasa',
      gradient: 'linear-gradient(135deg, #007fff 0%, #f7d618 100%)',
      url: '/partenaires/rd-congo'
    },
    {
      id: 'centrafrique',
      name: 'Centrafrique',
      countryCode: 'cf',
      city: 'Bangui',
      gradient: 'linear-gradient(135deg, #003082 0%, #289728 100%)',
      url: '/partenaires/centrafrique'
    },
    {
      id: 'tchad',
      name: 'Tchad',
      countryCode: 'td',
      city: 'N\'Djamena',
      gradient: 'linear-gradient(135deg, #002664 0%, #fecb00 100%)',
      url: '/partenaires/tchad'
    },
    {
      id: 'guinee',
      name: 'Guinée',
      countryCode: 'gn',

      gradient: 'linear-gradient(135deg, #ce1126 0%, #fcd116 100%)',
      url: '/partenaires/guinee'
    },
    // {
    //   id: 'mauritanie',
    //   name: 'Mauritanie',
    //   countryCode: 'mr',
    //   city: 'Nouakchott',
    //   gradient: 'linear-gradient(135deg, #006233 0%, #ffc61e 100%)',
    //   url: '/partenaires/mauritanie'
    // }
  ];

  return (
    <>
      <Header />
      <div className="partners-wrapper">
        {/* Hero Section Moderne */}
        <section className="hero-section">
          <div className="hero-background">
            <div className="floating-shape shape-1"></div>
            <div className="floating-shape shape-2"></div>
            <div className="floating-shape shape-3"></div>
          </div>

          <div className="container">
            <div className="hero-content">
              <div className="hero-badge">
                <FaGlobe className="badge-icon" />
                <span>Réseau International</span>
              </div>

              <h1 className="hero-title">
                Nos Partenaires <br />
                <span className="highlight">à travers le monde</span>
              </h1>

              <p className="hero-description">
                CINEF collabore avec des institutions et entreprises de premier plan dans 7 pays
                pour vous garantir des formations de qualité internationale et des certifications reconnues.
              </p>

              <div className="hero-stats">
                <div className="stat-item">
                  <FaGlobe className="stat-icon" />
                  <div className="stat-content">
                    <div className="stat-number">7</div>
                    <div className="stat-label">Pays</div>
                  </div>
                </div>
                <div className="stat-divider"></div>
                <div className="stat-item">
                  <FaHandshake className="stat-icon" />
                  <div className="stat-content">
                    <div className="stat-number">155+</div>
                    <div className="stat-label">Partenaires</div>
                  </div>
                </div>
                <div className="stat-divider"></div>
                <div className="stat-item">
                  <FaAward className="stat-icon" />
                  <div className="stat-content">
                    <div className="stat-number">15+</div>
                    <div className="stat-label">Ans d'expérience</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section Pays avec Cartes Premium */}
        <section className="countries-section">
          <div className="container">
            <div className="section-header">
              <div className="section-badge">
                <FaMapMarkedAlt />
                <span>Nos Implantations</span>
              </div>
              <h2 className="section-title">
                Découvrez nos partenaires <br />
                dans chaque pays
              </h2>
              <p className="section-subtitle">
                Sélectionnez un pays pour explorer notre réseau de partenaires locaux
              </p>
            </div>

            <div className="countries-grid">
              {countries.map((country) => (
                <a
                  key={country.id}
                  href={country.url}
                  className="country-card"
                >
                  <div className="card-gradient" style={{ background: country.gradient }}></div>

                  <div className="card-header">
                    <div className="flag-container">
                      <CountryFlag countryCode={country.countryCode} alt={`Drapeau ${country.name}`} />
                      <div className="flag-shine"></div>
                    </div>

                    <div className="country-info">
                      <h3 className="country-name">{country.name}</h3>
                      <p className="country-city">{country.city}</p>
                    </div>
                  </div>

                  <div className="card-footer">
                    <button className="view-button">
                      <span>Voir les entreprises</span>

                    </button>
                  </div>

                  <div className="card-hover-effect"></div>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* Section Avantages */}
        <section className="benefits-section">
          <div className="container">
            <div className="benefits-content">
              <div className="benefits-left">
                <h2 className="benefits-title">
                  Pourquoi travailler <br />
                  avec nos partenaires ?
                </h2>
                <p className="benefits-description">
                  Notre réseau de partenaires triés sur le volet garantit la qualité,
                  la reconnaissance et l'excellence de nos formations à l'international.
                </p>
              </div>

              <div className="benefits-grid">
                <div className="benefit-card">
                  <div className="benefit-icon">
                    <FaAward />
                  </div>
                  <h3>Certifications reconnues</h3>
                  <p>Des diplômes et certificats reconnus internationalement</p>
                </div>

                <div className="benefit-card">
                  <div className="benefit-icon">
                    <FaChartLine />
                  </div>
                  <h3>Excellence garantie</h3>
                  <p>Partenaires sélectionnés pour leur expertise</p>
                </div>

                <div className="benefit-card">
                  <div className="benefit-icon">
                    <FaHandshake />
                  </div>
                  <h3>Réseau solide</h3>
                  <p>Un réseau établi depuis plus de 15 ans</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <div className="container">
            <div className="cta-card">
              <div className="cta-content">
                <h2 className="cta-title">Rejoignez notre réseau</h2>
                <p className="cta-description">
                  Vous êtes une entreprise ou une institution et souhaitez devenir partenaire CINEF ?
                </p>
                <Link to="/devenir-partenaire" className="cta-link">
                  <button className="cta-button">
                    Devenir Partenaire

                  </button>
                </Link>
              </div>
              <div className="cta-decoration">
                <div className="decoration-blob blob-1"></div>
                <div className="decoration-blob blob-2"></div>
              </div>
            </div>
          </div>
        </section>

        <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .partners-wrapper {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
          background: #ffffff;
          overflow-x: hidden;
        }

        .container {
          max-width: 1280px;
          margin: 0 auto;
          padding: 0 24px;
        }

        /* Hero Section */
        .hero-section {
          position: relative;
          padding: 120px 0 100px;
          background: linear-gradient(180deg, #fafafa 0%, #ffffff 100%);
          overflow: hidden;
        }

        .hero-background {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 0;
        }

        .floating-shape {
          position: absolute;
          border-radius: 50%;
          opacity: 0.08;
          animation: float 80s ease-in-out infinite;
        }

        .shape-1 {
          width: 400px;
          height: 400px;
          background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
          top: -100px;
          right: -100px;
          animation-delay: 0s;
        }

        .shape-2 {
          width: 300px;
          height: 300px;
          background: linear-gradient(135deg, #198754 0%, #20c997 100%);
          bottom: -50px;
          left: -50px;
          animation-delay: 5s;
        }

        .shape-3 {
          width: 200px;
          height: 200px;
          background: linear-gradient(135deg, #8b5cf6 0%, #6366f1 100%);
          top: 50%;
          right: 10%;
          animation-delay: 10s;
        }

        @keyframes float {
          0%, 100% {
            transform: translate(0, 0) rotate(0deg);
          }
          33% {
            transform: translate(30px, -30px) rotate(120deg);
          }
          66% {
            transform: translate(-20px, 20px) rotate(240deg);
          }
        }

        .hero-content {
          position: relative;
          z-index: 1;
          text-align: center;
        }

        .hero-badge {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 12px 24px;
          background: white;
          border-radius: 50px;
          box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
          margin-bottom: 32px;
          font-size: 14px;
          font-weight: 600;
          color: #fd7e14;
        }

        .badge-icon {
          font-size: 18px;
          animation: rotate 8s linear infinite;
        }

        @keyframes rotate {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        .hero-title {
          font-size: 64px;
          font-weight: 900;
          line-height: 1.1;
          color: #1a202c;
          margin-bottom: 24px;
          letter-spacing: -2px;
        }

        .highlight {
          background: linear-gradient(135deg, #fd7e14 0%, #dc3545 50%, #198754 100%);
          background-size: 200% 200%;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          animation: gradientFlow 5s ease infinite;
        }

        @keyframes gradientFlow {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }

        .hero-description {
          font-size: 19px;
          line-height: 1.7;
          color: #4a5568;
          max-width: 750px;
          margin: 0 auto 48px;
        }

        .hero-stats {
          display: inline-flex;
          align-items: center;
          gap: 32px;
          padding: 32px 48px;
          background: white;
          border-radius: 20px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
        }

        .stat-item {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .stat-icon {
          font-size: 32px;
          color: #fd7e14;
        }

        .stat-number {
          font-size: 32px;
          font-weight: 900;
          color: #1a202c;
          line-height: 1;
          margin-bottom: 4px;
        }

        .stat-label {
          font-size: 13px;
          color: #718096;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .stat-divider {
          width: 1px;
          height: 50px;
          background: #e2e8f0;
        }

        /* Countries Section */
        .countries-section {
          padding: 100px 0;
          background: white;
        }

        .section-header {
          text-align: center;
          margin-bottom: 64px;
        }

        .section-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 8px 20px;
          background: linear-gradient(135deg, #fff5f0 0%, #ffe0b2 100%);
          border-radius: 50px;
          font-size: 14px;
          font-weight: 600;
          color: #fd7e14;
          margin-bottom: 20px;
        }

        .section-title {
          font-size: 48px;
          font-weight: 900;
          color: #1a202c;
          line-height: 1.2;
          margin-bottom: 16px;
          letter-spacing: -1px;
        }

        .section-subtitle {
          font-size: 18px;
          color: #718096;
          max-width: 600px;
          margin: 0 auto;
        }

        .countries-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 28px;
        }

        .country-card {
          position: relative;
          background: white;
          border-radius: 20px;
          overflow: hidden;
          border: 2px solid #e2e8f0;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          text-decoration: none;
          display: block;
          cursor: pointer;
        }

        .country-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
          border-color: transparent;
        }

        .card-gradient {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 6px;
          opacity: 0;
          transition: opacity 0.4s ease;
        }

        .country-card:hover .card-gradient {
          opacity: 1;
        }

        .card-header {
          padding: 32px 28px 28px;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          gap: 20px;
        }

        .flag-container {
          position: relative;
          width: 120px;
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%);
          border-radius: 12px;
          padding: 8px;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
          overflow: hidden;
        }

        .country-flag-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 8px;
          position: relative;
          z-index: 2;
          transition: transform 0.4s ease;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
        }

        .country-card:hover .country-flag-img {
          transform: scale(1.08);
        }

        .flag-shine {
          position: absolute;
          top: -100%;
          left: -100%;
          width: 200%;
          height: 200%;
          background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.3) 50%, transparent 70%);
          opacity: 0;
          transition: all 0.6s ease;
          z-index: 3;
        }

        .country-card:hover .flag-shine {
          opacity: 1;
          top: 100%;
          left: 100%;
        }

        .country-info {
          flex: 1;
        }

        .country-name {
          font-size: 24px;
          font-weight: 800;
          color: #1a202c;
          margin-bottom: 4px;
        }

        .country-city {
          font-size: 15px;
          color: #718096;
          font-weight: 500;
        }

        .card-body {
          padding: 0 32px 24px;
        }

        .partners-count {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 12px 20px;
          background: #f7fafc;
          border-radius: 12px;
          font-size: 14px;
          color: #4a5568;
          font-weight: 600;
          margin-bottom: 20px;
        }

        .count-icon {
          color: #fd7e14;
          font-size: 16px;
        }

        .card-decorations {
          display: flex;
          gap: 8px;
        }

        .decoration-circle {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #e2e8f0;
        }

        .card-footer {
          padding: 0 32px 32px;
        }

        .view-button {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          padding: 16px 24px;
          background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
          color: white;
          border: none;
          border-radius: 12px;
          font-size: 15px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.3s ease;
          font-family: inherit;
        }

        .view-button:hover {
          box-shadow: 0 8px 24px rgba(253, 126, 20, 0.4);
        }

        .arrow-icon {
          transition: transform 0.3s ease;
        }

        .view-button:hover .arrow-icon {
          transform: translateX(4px);
        }

        .card-hover-effect {
          position: absolute;
          top: -100%;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(180deg, transparent 0%, rgba(253, 126, 20, 0.03) 100%);
          transition: top 0.4s ease;
        }

        .country-card:hover .card-hover-effect {
          top: 0;
        }

        /* Benefits Section */
        .benefits-section {
          padding: 100px 0;
          background: linear-gradient(180deg, #fafafa 0%, #ffffff 100%);
        }

        .benefits-content {
          display: grid;
          grid-template-columns: 1fr 1.5fr;
          gap: 64px;
          align-items: center;
        }

        .benefits-title {
          font-size: 42px;
          font-weight: 900;
          color: #1a202c;
          line-height: 1.2;
          margin-bottom: 20px;
          letter-spacing: -1px;
        }

        .benefits-description {
          font-size: 17px;
          color: #4a5568;
          line-height: 1.7;
        }

        .benefits-grid {
          display: grid;
          gap: 24px;
        }

        .benefit-card {
          padding: 32px;
          background: white;
          border-radius: 16px;
          border: 2px solid #e2e8f0;
          transition: all 0.3s ease;
        }

        .benefit-card:hover {
          transform: translateX(8px);
          border-color: #fd7e14;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
        }

        .benefit-icon {
          width: 56px;
          height: 56px;
          background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 24px;
          margin-bottom: 20px;
        }

        .benefit-card h3 {
          font-size: 20px;
          font-weight: 700;
          color: #1a202c;
          margin-bottom: 8px;
        }

        .benefit-card p {
          font-size: 15px;
          color: #718096;
          line-height: 1.6;
        }

        /* CTA Section */
        .cta-section {
         padding: 100px 0;
         background: white;
        }

        .cta-card {
         position: relative;
         max-width: 900px;          
         margin: 0 auto;            
         padding: 64px 56px;
         background: linear-gradient(
         135deg,
         #1f3d2b 0%,
         #2f5d46 100%
         );                         
         border-radius: 28px;
         overflow: hidden;
         text-align: center;
       }


        .cta-content { 
          position: relative;
          z-index: 2;
        }

        .cta-title {
          font-size: 42px;
          font-weight: 900;
          color: white;
          margin-bottom: 16px;
        }

        .cta-description {
          font-size: 18px;
          color: rgba(255, 255, 255, 0.9);
          max-width: 600px;
          margin: 0 auto 32px;
          line-height: 1.7;
        }

        .cta-button {
          display: inline-flex;
          align-items: center;
          gap: 12px;
          padding: 18px 36px;
          background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
          color: white;
          border: none;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.3s ease;
          font-family: inherit;
        }

        .cta-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 12px 32px rgba(253, 126, 20, 0.4);
        }

        .cta-decoration {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 1;
        }

        .decoration-blob {
          position: absolute;
          border-radius: 50%;
          opacity: 0.1;
        }

        .blob-1 {
          width: 400px;
          height: 400px;
          background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
          top: -150px;
          right: -150px;
        }

        .blob-2 {
          width: 300px;
          height: 300px;
          background: linear-gradient(135deg, #198754 0%, #20c997 100%);
          bottom: -100px;
          left: -100px;
        }

        /* Responsive */
        @media (max-width: 1024px) {
          .hero-title {
            font-size: 48px;
          }

          .section-title {
            font-size: 36px;
          }

          .benefits-content {
            grid-template-columns: 1fr;
            gap: 48px;
          }

          .hero-stats {
            flex-direction: column;
            gap: 24px;
            padding: 32px;
          }

          .stat-divider {
            width: 100%;
            height: 1px;
          }
        }

        @media (max-width: 768px) {
          .hero-title {
            font-size: 36px;
          }

          .countries-grid {
            grid-template-columns: 1fr;
          }

          .section-title {
            font-size: 32px;
          }

          .benefits-title {
            font-size: 32px;
          }

          .cta-card {
            padding: 48px 32px;
          }

          .cta-title {
            font-size: 32px;
          }
        }

        @media (max-width: 480px) {
          .hero-title {
            font-size: 28px;
            letter-spacing: -1px;
          }

          .hero-stats {
            padding: 24px;
          }

          .stat-number {
            font-size: 28px;
          }

          .section-title {
            font-size: 28px;
          }
        }
      `}</style>
      </div>
      <Footer />
    </>
  );
};

export default NosPartenaires;